import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import { withRouter } from "../../../app-services/lib/router-compat";
import Booklet from "../../../components/Booklet/Booklet";
import CheckoutSteps from "../../preview/CheckoutSteps/CheckoutSteps";
import "./BookPreview.css";

export function BookPreview(props) {
  const self = useRef({}).current;
  const { onFetch = (...arg) => api.getSelfPublish(...arg) } = props;
  const CUSTOMBOOKID = props.bookDetails.id;
  const $ele = useRef(null);
  const [pages, setPages] = useState([]);
  const [bookDetails, setBookDetails] = useState(null);
  const [productDetails, setProductDetails] = useState(null);
  const [answers, setAnswers] = useState({});
  const [parsedBook, setParsedBook] = useState(null);
  const [bookobj, setBookobj] = useState(null);
  const prevStateRef = useRef(null);

  const state = { pages, bookDetails, productDetails, answers, parsedBook, bookobj };

  self.props = props;

  useLayoutEffect(() => {
    initialConstruct.bind(self)("BookPreview", props);
    self.onFetch = onFetch;
    self.CUSTOMBOOKID = CUSTOMBOOKID;
    self.$ele = $ele;
  }, []);

  self.state = state;
  self.setState = (update) => {
    if (typeof update === "function") {
      const next = update(state, props);
      if (next.pages !== undefined) setPages(next.pages);
      if (next.bookDetails !== undefined) setBookDetails(next.bookDetails);
      if (next.productDetails !== undefined) setProductDetails(next.productDetails);
      if (next.answers !== undefined) setAnswers(next.answers);
      if (next.parsedBook !== undefined) setParsedBook(next.parsedBook);
      if (next.bookobj !== undefined) setBookobj(next.bookobj);
    } else {
      if (update.pages !== undefined) setPages(update.pages);
      if (update.bookDetails !== undefined) setBookDetails(update.bookDetails);
      if (update.productDetails !== undefined) setProductDetails(update.productDetails);
      if (update.answers !== undefined) setAnswers(update.answers);
      if (update.parsedBook !== undefined) setParsedBook(update.parsedBook);
      if (update.bookobj !== undefined) setBookobj(update.bookobj);
    }
  };

  const onBookSetup = (bookobjVal) => {
    setBookobj(bookobjVal);
    let previewPageNo = localStorage.getItem("previewPageNo");
    if (previewPageNo) {
      setTimeout(() => {
        bookobjVal.turnToPage(Number(previewPageNo));
        localStorage.removeItem("previewPageNo");
      }, 100);
    }
  };

  const getPages = () => {
    let { getPayload } = props;
    return new Promise((resolve, reject) => {
      getPayload()
        .then((book) => {
          resolve(
            Object.entries(book).map(([key, value], i) => ({
              pagetype: key,
              name: key,
              label: i + 1,
              content: value.html,
            }))
          );
        })
        .catch((err) => reject(err));
    });
  };

  const getProductDetails = () => {
    let { bookDetails: propsBookDetails } = props;
    //console.log(bookDetails);
    api.getBookDetails(propsBookDetails.bookId).then((res) => {
      setProductDetails(res.data.bookDetails);
    });
  };

  const getBookDetails = () => {
    let { bookDetails: propsBookDetails } = props;
    return new Promise((resolve, reject) => {
      if (propsBookDetails.id) {
        onFetch(propsBookDetails.id).then((responce) => {
          if (responce.data && Object.keys(responce.data).length) {
            let savedBookObj = responce.data || { savedBook: "{}" };
            let parsedBookVal = savedBookObj.savedBook?.parse() || {};
            setBookDetails(savedBookObj);
            setParsedBook(parsedBookVal);
            resolve(savedBookObj);
          }
        });
      }
    });
  };

  const getPageSize = (name) => {
    let { bookname } = props;
    let booksize = self.$store?.bookSize?.[bookname];
    if (booksize && booksize[name]) {
      return `${booksize[name]}${booksize["unit"]}`;
    } else {
      return "";
    }
  };

  const getCorrection = (attributeName) => {
    let device = self.$store?.device;
    let correct = 0;
    let { bookname } = props;
    //console.log({getCorrection:bookname});
    if(["picture-book","handprint-book"].includes(bookname)) {
      switch(device) { 
        case "desk": correct = `${(1-0.8).toFixed(2).parse()*200}mm`.toPx(); break; 
        case "lap":
        case "mac": correct = `${(1-0.6).toFixed(2).parse()*200}mm`.toPx(); break;
      }
    }
    return correct;
  };

  const getPageWidth = () => {
    return getPageSize("width").toPx() - getCorrection("width");
  };

  const getPageHeight = () => {
    return getPageSize("height").toPx() - getCorrection("height");
  };

  const getStyle = () => {
    return {
      "--bookHeight": getPageSize("height"),
      "--bookWidth": getPageSize("width"),
    };
  };

  const onPage = (obj, i, arr) => {
    return {
      ...obj,
      content: () => (
        <div>
          <div dangerouslySetInnerHTML={{ __html: obj.content || "" }}></div>
          <div className="col text-center">
            <b>{obj.label}</b> / {arr.length}
          </div>
        </div>
      ),
    };
  };

  const onAnswer = (value, key) => {
    let { onUpdate } = props;
    if (key == "dedication") {
      onUpdate(key, value);
    }
    setAnswers((prevAnswers) => ({
      ...prevAnswers,
      [key]: value,
    }));
  };

  const onDedicationSave = () => {
    let { saveBook, bookname } = props;
    return new Promise((resolve,reject)=>{
      saveBook().then(() => {
        props.alert.close();
        setTimeout(() => {
          if(bookname === 'customcharacter-book'){
            localStorage.setItem("previewPageNo", 18);
          }
          document.querySelector(".right-toolbar #previewBook").click();
          resolve();
        }, 100);
      }).catch(reject);
    });
  };

  const checkoutSave = () => {
    return new Promise((resolve,reject)=>{
      onDedicationSave().then(()=>{
        setProductDetails((prev) => ({...bookDetails,triggeradd2cart:true}));
        self.setStore('triggeradd2cart',true);
      });
    });
  };

  const addToCart = () => {
    let { saveBook,getPayload } = props;
    let { history } = self;
    //console.log({addToCart:productDetails});
    mixins.checkLogin(history).then(async (user)=>{
      if (!productDetails) {
        checkoutSave();
        return;
      } else {
        let payload = await getPayload();
        await emit.trigger('updatebook',payload);
      }
      Modal.state.list.filter((o) => o.type == "alert")[0]?.close();
      if (localStorage.getItem("editmode") === "true") {
        api.updateToCart(
            {
              promotionId: null,
              productId: productDetails?.product?.id,
              quantity: 1,
              price: productDetails?.book?.bookPrice,
              discount: null,
              bookCover: answers.cover || null,
              customProductId: props.store.cartdetails?.customProductId,
            },
            props.store.cartdetails?.id
          )
          .then((res) => {
            localStorage.setItem("editmode",false)
            if (res && res.statusCode === 200) {
              props.alert.close();
              history.push("/checkout-page");
            } else {
              alert("Something went wrong please try again later..");
            }
          });
      } else {
       // console.log("addding to cart");
        api
          .addToCart({
            promotionId: null,
            productId: productDetails?.product?.id,
            quantity: 1,
            price: productDetails?.book?.bookPrice,
            discount: null,
            bookCover: answers.cover || null,
            customBookId: bookDetails.customBook.id,
          })
          .then((res) => {
            if (res && res.statusCode === 200) {
              props.alert.close();
              history.push("/checkout-page");
              mixins.reFectchSavedBookDetails(props);
            } else {
              alert("Something went wrong please try again later..");
            }
          });
      }
    });
  };

  self.onBookSetup = onBookSetup;
  self.getPages = getPages;
  self.getProductDetails = getProductDetails;
  self.getBookDetails = getBookDetails;
  self.getPageSize = getPageSize;
  self.getCorrection = getCorrection;
  self.getPageWidth = getPageWidth;
  self.getPageHeight = getPageHeight;
  self.getStyle = getStyle;
  self.onPage = onPage;
  self.onAnswer = onAnswer;
  self.onDedicationSave = onDedicationSave;
  self.checkoutSave = checkoutSave;
  self.addToCart = addToCart;

  const getStepKeys = () => {
    let { bookname } = props;
    switch (bookname) {
      case "customcharacter-book":
        return ["edit","dedication"];
      case "handprint-book":
          return ["edit"];
      default:
        return [];
    }
  };

  useEffect(() => {
    window.BookPreview = self;
    getPages().then((pagesVal) => {
      setPages(pagesVal);
      getBookDetails().then(() => {
        getProductDetails();
      });
    });
  }, []);

  useEffect(() => {
    mixins.debounce(document, () => {}, "customCharacter.8.ans.dedication");
    self.watch({
      productDetails:function(val) {
        if(props.store.triggeradd2cart) {
          self.setStore('triggeradd2cart',false);
          setTimeout(()=>{
            addToCart();
          });
        }
      }
    }, state, prevStateRef.current || state);
    prevStateRef.current = state;
  });

  let { bookname, alert, message, closablePreview=true, onPreviewClose=(a)=>a.close() } = props;
  return (
    <div className={'BookPreview '+bookname} style={getStyle()} ref={$ele} >
      { closablePreview && <i className="close fa fa-times" onClick={() => onPreviewClose(alert) }></i> }
      <div className='mt-5'>
      {
        (pages.length > 0) && <Booklet
          onSetup={(bookObj)=>onBookSetup(bookObj)}
          pageWidth={getPageWidth()}
          pageHeight={getPageHeight()}
          pages={pages}
          onPage={(...arg) => onPage(...arg)}
        />
      }
      </div>
      <div className='mt-4'>
        {
          message && <div className="col text-center" style={{fontWeight: 'bold', color: 'red'}} dangerouslySetInnerHTML={{__html:message}}>
          </div>
        }
      </div>
      <div className='my-5' >
      {
        <CheckoutSteps
          keys={getStepKeys()}
          addToCart={() => addToCart()}
          onAnswer={(v, k) => onAnswer(v, k)}
          onSave={(v)=>onDedicationSave(v)}
          bookname={bookname}
        />
      }
      </div>
    </div>
  );
}

export default connect(withRouter(BookPreview));
